import { nanpPostalCodePattern } from "@homeinstead/locale";

function filterAreaServed(areaServed: string[]): string[] {
  return (Array.isArray(areaServed) ? areaServed : [])
    .map((area) => (typeof area === "string" ? area.trim() : null))
    .filter(
      (area) =>
        typeof area === "string" &&
        area.length > 0 &&
        nanpPostalCodePattern.test(area),
    );
}

export { filterAreaServed };
